import React, { useState } from "react";
import Header from "../home/header";
import repImage from '../../img/customer.svg';
import { useLocation, useNavigate, useParams } from "react-router";
import UTILS from "../../utils/commons";
import Loading from "../home/Loading";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ApiClient } from "../../utils/api-client";
import { getCityNames } from "postcodes-tz";
const CustomerEditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const apiClient = new ApiClient( loginState.accessToken, null )
  const customerData = location.state || {};
  const { id } = useParams();
  const [ isLoading, setIsLoading ] = useState( false );
  const [ feedback, setFeedback ] = useState( "" );
  const [ preview, setPreview ] = useState(
    customerData?.customerImage || repImage
  );

  const formik = useFormik( {
    initialValues: {
      name: customerData?.name || customerData.name,
      address: customerData?.address || customerData.address,
      phone: customerData?.phone || customerData.phone,
      email: customerData?.email || customerData.email,
      region: customerData?.region || '',
      customerImage: null,
    },
    validationSchema: Yup.object( {
      name: Yup.string().required( "Name is required" ),
      address: Yup.string().required( "Address is required" ),
      phone: Yup.string().required( "Phone is required" ),
      region: Yup.string().required( "Region is required" ),
      email: Yup.string().email( "Invalid email" ),
    } ),
    onSubmit: async ( values ) => {
      setIsLoading( true );
      const payload = {
        id,
        name: values.name,
        address: values.address,
        phone: values.phone,
        email: values.email,
        region: values.region,
        profileId: loginState.profile.id,
        customerImage: values.customerImage || customerData?.customerImage,
      };
      try {
        const res = await apiClient.patch( `customers/${id}`, payload );
        if ( res.status === 200 ) {
          customerData.customers = res.data.customers;
          navigate( "/customers", { replace: true, state: customerData } );
        } else {
          setFeedback( res.data.msg );
        }
      } catch ( e ) {
        setFeedback( 'Oops! Something went wrong' );
      } finally {
        setIsLoading( false );
      }
    },
  } );

  const handleImageChange = ( e ) => {
    const file = e.target.files[ 0 ];
    if ( file ) {
      let reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result;
        setPreview( dataUrl );
        formik.setFieldValue( "customerImage", reader.result );
      };
      reader.readAsDataURL( file );
    }
  };

  return (
    <>
      <Header auth={loginState} />
      <section className="container mx-auto mt-8">
        {feedback && feedback.length > 0 ? (
          <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="feedback">{feedback}</div>
        ) : null}

        <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5 mb-4">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Module</p>
              <p className="text-lg font-semibold text-gray-800 mt-1">Customers</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Action</p>
              <p className="text-lg font-semibold text-gray-800 mt-1">Edit</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Customer</p>
              <p className="text-lg font-semibold text-gray-800 mt-1 truncate" title={formik.values.name}>{formik.values.name || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-gray-200 bg-white shadow-md p-4 md:p-6">
          <div className="flex items-center justify-between mb-5">
            <div>
              <p className="text-sm uppercase tracking-wide text-gray-500">Customer Setup</p>
              <p className="text-2xl font-semibold text-gray-800">Edit Customer</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
            <div className="md:col-span-1 rounded-xl border border-gray-200 bg-gray-50 p-4 text-center">
              <img id="rep_preview" src={preview} alt="Customer feature" className="h-36 w-36 rounded-full object-cover border-2 border-primary-200 mx-auto" />
              <p className="text-sm text-gray-500 mt-3">Image Preview</p>
            </div>
            <div className="md:col-span-2">
              <form id="edit_customer_form"
                className="w-full"
                method="post"
                onSubmit={formik.handleSubmit}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="name" className="text-sm text-gray-600">Customer Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      required
                      placeholder="Customer name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-danger small">{formik.errors.name}</div>
                    ) : null}
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="customer_image" className="text-sm text-gray-600">Customer Image</label>
                    <input
                      type="file"
                      className="form-control"
                      id="customer_image"
                      name="customer_image"
                      placeholder="Upload customer image"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                    {formik.values.customerImage && (
                      <div className="text-success small">Image selected</div>
                    )}
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="address" className="text-sm text-gray-600">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      name="address"
                      required
                      placeholder="Address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <div className="text-danger small">{formik.errors.address}</div>
                    ) : null}
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="region" className="text-sm text-gray-600">Region</label>
                    <select
                      className="form-control"
                      id="region"
                      name="region"
                      value={formik.values.region}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="">Select Region</option>
                      {getCityNames( 'ASC' ).map( ( city, index ) => (
                        <option key={index} value={city}>{city}</option>
                      ) )}
                    </select>
                    {formik.touched.region && formik.errors.region ? (
                      <div className="text-danger small">{formik.errors.region}</div>
                    ) : null}
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="phone" className="text-sm text-gray-600">Phone Number</label>
                    <input
                      type="number"
                      className="form-control"
                      id="phone"
                      name="phone"
                      required
                      placeholder="Phone Number"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="text-danger small">{formik.errors.phone}</div>
                    ) : null}
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="email" className="text-sm text-gray-600">E-mail</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="E-mail"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-danger small">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>
                <div className="form-group mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    {isLoading ? (
                      <Loading />
                    ) : (
                      <input
                        type="submit"
                        className="form-control bg-success"
                        id="btnSubmit"
                        name="btnSubmit"
                        value="Update Customer"
                      />
                    )}
                  </div>
                  <div>
                    <input
                      onClick={() => {
                        navigate( "/customers", { replace: true, state: customerData } );
                      }}
                      type="button"
                      className="form-control"
                      value="Back to Customers"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CustomerEditForm;
